import { Button, Textarea } from 'components';
import { useTranslations } from 'next-intl';
import { ChangeEvent, FC } from 'react';
import { connect } from 'react-redux';

import { updateInputField, useSelectionContentFlow } from './_actions';
import { getShouldPreventEditing } from './_selectors';

interface ITextFlow {
  useSelectionContentFlow: () => void;
  updateInputField: (data: { field: string; value: string }) => void;
  shouldPreventEditing: boolean;
}

const TextFlow: FC<ITextFlow> = ({
  useSelectionContentFlow: selectionContentFlow,
  updateInputField,
  shouldPreventEditing
}) => {
  const t = useTranslations();

  const handlerOnChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
    e.preventDefault();
    // selectionContentFlow();
    updateInputField({ field: 'copy', value: e.target.value });
  };

  return (
    <span className="flex w-[700px] flex-col">
      <Textarea
        placeholder={t('ordering_form.type_or_paste_here')}
        onChange={handlerOnChange}
        disabled={shouldPreventEditing}
        className="h-[70vh]"
      />
      <div className="mt-4 flex justify-center">
        <Button
          label={t('ordering_form.back_to_selection')}
          onClick={selectionContentFlow}
          size="medium"
          variant="text"
        />
      </div>
    </span>
  );
};

export default connect(
  (state) => ({
    shouldPreventEditing: getShouldPreventEditing(state)
  }),
  { useSelectionContentFlow, updateInputField }
)(TextFlow);
